// Collect.JS validation fields
export enum EValidationFields {
  CC_NUMBER = 'ccnumber',
  CVV = 'cvv',
  CC_EXPIRY = 'ccexp',
}
